// INVITES
export const REQ_PRODUCT_ACCESS_INVITE_USERS = 'REQ_PRODUCT_ACCESS_INVITE_USERS';
export const CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT =
  'CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT';
export const CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT_CLEAR =
  'CLIENT_PRODUCT_ACCESS_INVITE_USERS_RESULT_CLEAR';
export const REQ_PRODUCT_ACCESS_CANCEL_INVITES = 'REQ_PRODUCT_ACCESS_CANCEL_INVITES';
export const CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT =
  'CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT';
export const CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT_CLEAR =
  'CLIENT_PRODUCT_ACCESS_CANCEL_INVITES_RESULT_CLEAR';
export const REQ_PRODUCT_ACCESS_RESEND_INVITES = 'REQ_PRODUCT_ACCESS_RESEND_INVITES';
export const CLIENT_PRODUCT_ACCESS_RESEND_INVITES_RESULT =
  'CLIENT_PRODUCT_ACCESS_RESEND_INVITES_RESULT';
export const CLIENT_PRODUCT_ACCESS_RESEND_INVITES_RESULT_CLEAR =
  'CLIENT_PRODUCT_ACCESS_RESEND_INVITES_RESULT_CLEAR';
export const CLIENT_PRODUCT_ACCESS_INVITES_SYNC = 'CLIENT_PRODUCT_ACCESS_INVITES_SYNC';

// SHARED COMPUTERS
export const REQ_USER_ADMIN_ADD_SHARED_COMPUTER = 'REQ_USER_ADMIN_ADD_SHARED_COMPUTER';
export const CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT =
  'CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT';
export const CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT_CLEAR =
  'CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT_CLEAR';
export const REQ_USER_ADMIN_MODIFY_SHARED_COMPUTER = 'REQ_USER_ADMIN_MODIFY_SHARED_COMPUTER';
export const CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT =
  'CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT';
export const CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT_CLEAR =
  'CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT_CLEAR';

// FORCE UPDATE THE ADMIN SYNC DATA
export const REQ_ADMIN_SYNC_FORCE_UPDATE = 'REQ_ADMIN_SYNC_FORCE_UPDATE';
